import CourseDetailCard from '../CourseDetailCard/CourseDetailCard';
import CourseDetailCardContent from '../CourseDetailCard/CourseDetailCardContent/CourseDetailCardContent';
import CourseDetailCardHeader from '../CourseDetailCard/CourseDetailCardHeader/CourseDetailCardHeader';
import styles from './CourseDetailCardList.module.scss';
import type { CourseDetailCardListProps } from './types';

const CourseDetailCardList = ({ items }: CourseDetailCardListProps) => {
  return (
    <div className={styles.base}>
      {items.map(({ title, content, startTime, endTime }, index) => {
        const dayNumber = index + 1;

        return (
          <CourseDetailCard key={title + dayNumber}>
            <CourseDetailCardHeader title={title}>
              {(startTime || endTime) &&
                `${[startTime, endTime].filter(Boolean).join(' - ')} Uhr`}
            </CourseDetailCardHeader>

            <CourseDetailCardContent>{content}</CourseDetailCardContent>
          </CourseDetailCard>
        );
      })}
    </div>
  );
};

export default CourseDetailCardList;
